import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import { BaseGeneralConfig, GeneralPartConfig } from "../../general-scenario-stuff";
import { GeneralStepCollection } from "../../GeneralStepCollection";
import GeneralProceduresBvmPart1 from "./parts/GeneralProceduresBvmPart1";
import GeneralProceduresBvmPart2 from "./parts/GeneralProceduresBvmPart2";

export default class GeneralProceduresBvmMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	private _partId2 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralProceduresBvmMainConfig) {
		super();
		var context = this;
		context._parts.push(new GeneralProceduresBvmPart1(config.scenario, () => {
			context.goToStep2();
		}, () => {
			if(config.onAbort) {
				config.onAbort();
			}
		}, context._partId1, config));

		context._parts.push(new GeneralProceduresBvmPart2(this, config.scenario, () => {
			config.onDone();
		}, context._partId2, config))
	}

	public start() {
		this.goToStep1();
	}

	goToStep1() {
		this.config.scenario.loadPart(this._partId1);
	}

	goToStep2() {
		this.config.scenario.loadPart(this._partId2);
	}
}

export interface GeneralProceduresBvmMainConfig extends BaseGeneralConfig {
	scenario: DaarcBaseScenario;
	part1Config?: GeneralProceduresBvmPart1Config;
	part2Config?: GeneralProceduresBvmPart2Config;
	onMakeAttemptClicked?: (isOneHanded: boolean, isOPA: boolean, isNPA: boolean, isManipulateHeadAndNeck: boolean) => void;
	onChooseAnotherTechniqueClicked?: () => void;
	isAttemptSuccessful: () => boolean;
	isTempSuccess: () => boolean;
	onDone: () => void;
	onAbort: () => void;
}

export interface GeneralProceduresBvmPart1Config extends GeneralPartConfig {
	isToolEnabled?: () => boolean;
	onMakeAttemptClicked?: (isNPAClicked: boolean, isOPAClicked: boolean) => void;
	onAbortClicked?: () => void;
	onChooseHandNextClicked?: (isOneHanded: boolean) => void;
	chooseHandVideoChapter?: () => string
}

export interface GeneralProceduresBvmPart2Config extends GeneralPartConfig {
	attempt1AudioPath?: string;
	attempt2AudioPath?: string;
	attempt3AudioPath?: string;
	attempt4AudioPath?: string;
	onProcedureAttempted?: (attemptCount: number) => void;
	onProcedureAttemptedMoreThan3Times?: () => void
}